import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-unsubscribe-email-notify',
  imports: [TegelModule, RouterModule],
  templateUrl: './unsubscribe-email-notify.component.html',
  styleUrl: './unsubscribe-email-notify.component.scss',
  standalone: true,
})
export class UnsubscribeEmailNotifyComponent {
  landingPage = '/';
  id = '';
  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    this.id = urlParams.get('id') || '';

    if(this.id) {
      // Call API to process unsubscription using this.id
    }
  }
  constructor() {}
}
